export const STATUS = [
  {value: 'pending', text:'Pending'},
  {value: 'processing', text:'On route'},
  {value: 'completed', text:'Completed'},
  {value: 'cancelled', text:'Cancelled'}
];

export const STATUSMONITOR = [
  {value: 'pending', text:'Pending'},
  {value: 'processing', text:'Processing'},
  {value: 'on_hold', text:'On_hold'},
  {value: 'completed', text:'Completed'},
];

export const MONITORORDERBY = [
  {value: 'date', text:'date'},
  {value: 'hour_start', text:'hour_start'},
  {value: 'hour_end', text:'hour_end'},
  {value: 'trip_status', text:'trip_status'},
  {value: 'driver', text:'driver'},
  {value: 'eco_number', text:'eco_number'}, 
];

export const MONITORORDER = [
  {value: 'asc', text:'ascendente'},
  {value: 'desc', text:'descendente'},
];
